<template>
  <div class="c-tab-user">
    <Tabs v-model="tabRole" class="tab-user__wrapper" :animated="false">
      <TabPane name="tabrole" label="用户数据">
        <user-role
          v-if="tabRole === 'tabrole'"
          :asyning="loading"
          :keyword="keyword"
          v-bind="$attrs"
          ref="userRole"
          @on-change="changeAsyn"
        />
      </TabPane>
      <TabPane name="tabrecharge" label="充值明细">
        <user-recharge
          v-if="tabRole === 'tabrecharge'"
          ref="userRecharge"
          :asyning="loading"
          :date-pick="datetime"
          :keyword="keyword"
          v-bind="$attrs"
          @on-change="changeAsyn"
        />
      </TabPane>
      <template slot="extra">
        <div class="side-form">
          <Input
            v-model="keyword"
            search
            placeholder="请输入账号ID或者角色"
            style="width: 168px"
            class="extra-item"
            @on-search="searchFilter"
          />

          <div class="role-date">
            <DateRangePicker
              v-if="tabRole === 'tabrecharge'"
              v-model="datetime"
              @change="handleDateTime"
              style="width: 220px"
              :clearable="false"
            ></DateRangePicker>
          </div>

          <Button icon="md-download" class="extra-item" :loading="loading" @click="downData">数据导出</Button>
          <Button class="extra-item" :loading="loading" @click="handleCustom">自定义列</Button>
        </div>
      </template>
    </Tabs>
  </div>
</template>
<script>
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { timeout, deepCopy } from '@/common/js/utils'
import UserRole from '../table/user-role'
import UserRecharge from '../table/user-recharge'
export default {
  name: 'TabUser',
  components: { UserRole, DateRangePicker, UserRecharge },
  data() {
    return {
      datetime: [],
      loading: null,
      keyword: '',
      tabRole: 'tabrole'
    }
  },
  methods: {
    changeAsyn(bool) {
      this.loading = bool
    },
    handleDateTime(val) {
      this.datetime = val
      timeout(0).then(() => {
        this.filterData()
      })
    },
    handleCustom() {
      if (this.tabRole === 'tabrecharge' && this.$refs.userRecharge) this.$refs.userRecharge.modalColumn = true
      else if (this.$refs.userRole) this.$refs.userRole.modalColumn = true
    },
    filterData() {
      if (this.tabRole === 'tabrecharge' && this.$refs.userRecharge) this.$refs.userRecharge.filterData()
      else if (this.$refs.userRole) this.$refs.userRole.filterData()
    },
    searchFilter() {
      if (this.tabRole === 'tabrecharge' && this.$refs.userRecharge) this.$refs.userRecharge.searchFilterData()
      else if (this.$refs.userRole) this.$refs.userRole.searchFilterData()
    },
    downData() {
      if (this.tabRole === 'tabrecharge' && this.$refs.userRecharge) this.$refs.userRecharge.downData()
      else if (this.$refs.userRole) this.$refs.userRole.downData()
    }
  },
  created() {
    this.datetime = deepCopy(this.$attrs.detailTime)
  }
}
</script>
<style lang="scss" scoped>
.side-form {
  display: flex;
  > div,
  > button {
    margin-left: 5px;
  }
}
::v-deep.c-tab-user {
  height: 100%;
  margin-top: 8px;

  .tab-user__wrapper {
    height: 100%;

    .ivu-tabs-bar {
      border: none;
    }
    .ivu-tabs-nav-container {
      border-bottom: 1px solid #dcdee2;
    }
  }
}
</style>
